import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { apiClient, extractApiError } from '../api/axios';
import { API } from '../constants/api';

const initialState = {
  loading: false,
  error: '',
  success: false,
  deleted: false,
  promotions: [],
  promotionModal: false,
};

export const fetchPromotions = createAsyncThunk('vendorPromotions/fetchPromotions', async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.get(API.promotions.list);
    return response.data;
  } catch (error) {
    return rejectWithValue(extractApiError(error));
  }
});

export const createPromotion = createAsyncThunk(
  'vendorPromotions/createPromotion',
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiClient.post(API.promotions.list, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(extractApiError(error));
    }
  }
);

export const updatePromotion = createAsyncThunk(
  'vendorPromotions/updatePromotion',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await apiClient.put(API.promotions.byId(id), formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(extractApiError(error));
    }
  }
);

export const deletePromotion = createAsyncThunk(
  'vendorPromotions/deletePromotion',
  async ({ id }, { rejectWithValue }) => {
    try {
      await apiClient.del(API.promotions.byId(id));
      return id;
    } catch (error) {
      return rejectWithValue(extractApiError(error));
    }
  }
);

export const vendorPromotionsSlice = createSlice({
  name: 'vendorPromotions',
  initialState,
  reducers: {
    setPromotionModal: (state, { payload }) => {
      state.promotionModal = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPromotions.pending, (state) => {
      state.loading = true;
      state.error = '';
      state.success = false;
    });
    builder.addCase(fetchPromotions.fulfilled, (state, action) => {
      state.loading = false;
      state.promotions = action.payload.results;
      state.success = true;
    });
    builder.addCase(fetchPromotions.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.success = false;
      toast.error(state.error);
    });

    builder.addCase(createPromotion.pending, (state) => {
      state.loading = true;
      state.error = '';
      state.success = false;
    });
    builder.addCase(createPromotion.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.promotions.unshift(action.payload);
      toast.success('Aksiya yaratildi');
    });
    builder.addCase(createPromotion.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
      toast.error(state.error);
    });

    builder.addCase(updatePromotion.fulfilled, (state, action) => {
      state.success = true;
      const updated = action.payload;
      const index = state.promotions.findIndex((p) => p.id === updated.id);
      if (index !== -1) {
        state.promotions[index] = updated;
      }
      toast.success('Aksiya yangilandi');
    });
    builder.addCase(updatePromotion.rejected, (state, action) => {
      state.error = action.payload;
      toast.error(state.error);
    });

    builder.addCase(deletePromotion.fulfilled, (state, action) => {
      state.deleted = true;
      state.promotions = state.promotions.filter((p) => p.id !== action.payload);
      toast.success("Aksiya o'chirildi");
    });
    builder.addCase(deletePromotion.rejected, (state, action) => {
      state.error = action.payload;
      toast.error(state.error);
    });
  },
});

export const { setPromotionModal } = vendorPromotionsSlice.actions;

export default vendorPromotionsSlice.reducer;
